export default {
  state: {
    user: null,
    token: null,
    loginRequest: false,
  },
  mutations: {
    setUserData (state, userData) {
      state.user = userData;
      localStorage.setItem('user', JSON.stringify(userData));
      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`;
    },
    clearUserData () {
      localStorage.removeItem('user');
      location.reload();
    },
    setLoginRequest: (state, payload) => {
      state.loginRequest = payload;
    }
  },
  actions: {
    login ({ commit }, credentials) {
      return axios
        .post('api/v1/auth/login', credentials)
        .then(({ data }) => {
          commit('setUserData', data);
        })
    },
    register ({ commit }, credentials) {
      return axios
        .post('api/v1/auth/register', credentials)
        .then(({ data }) => {})
    },
    logout ({ commit }) {
      commit('clearUserData');
    }
  },
  getters : {
    isLogged: state => !!state.user
  }
}
